/**
 * @generated SignedSource<<bf98a849248f1ddd062b0de16be2eff0>>
 * @relayHash 3b4ed9279023ef8da539915b42c04f9c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3b4ed9279023ef8da539915b42c04f9c

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type fetchDeProgressNoteBetterDocResultQuery$variables = {
  progressNoteId: string;
};
export type fetchDeProgressNoteBetterDocResultQuery$data = {
  readonly de_progressNoteById: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"deProgressNoteBetterDocResultFragment">;
  } | null;
};
export type fetchDeProgressNoteBetterDocResultQuery = {
  response: fetchDeProgressNoteBetterDocResultQuery$data;
  variables: fetchDeProgressNoteBetterDocResultQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "progressNoteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "progressNoteId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchDeProgressNoteBetterDocResultQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "de_ProgressNote",
        "kind": "LinkedField",
        "name": "de_progressNoteById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "deProgressNoteBetterDocResultFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "fetchDeProgressNoteBetterDocResultQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "de_ProgressNote",
        "kind": "LinkedField",
        "name": "de_progressNoteById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": "betterDocResult",
            "args": null,
            "concreteType": "de_ProgressNoteBetterDocResult",
            "kind": "LinkedField",
            "name": "de_betterDocResult",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sessionId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "de_BetterDocRecommendedCareProvider",
                "kind": "LinkedField",
                "name": "recommendedCareProviders",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "position",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "workplaceName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "street",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "postalCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "3b4ed9279023ef8da539915b42c04f9c",
    "metadata": {},
    "name": "fetchDeProgressNoteBetterDocResultQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9bc9ac1b45269dad6fc14d2a98024c58";

export default node;
